<template>
  <v-container>
    <h2 class="mb-1">Download Our App</h2>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-container>
            <div>
              <v-img src="../../assets/img/download-app-store.jpeg" />
            </div>
            <div class="mt-3">
              <v-btn
                href="https://apps.apple.com/ng/app/snappy-exchange/id1609980240"
                target="_blank"
                large
                block
                color="primary"
              >
                Download
              </v-btn>
            </div>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-container>
            <div>
              <v-img src="../../assets/img/download-play-store.jpeg" />
            </div>
            <div class="mt-3">
              <v-btn
                target="_blank"
                href="https://play.google.com/store/apps/details?id=esw.snappyexchange.snappyexchange&hl=en"
                large
                block
                color="accent"
              >
                Download
              </v-btn>
            </div>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      siteData: (state) => state.user.siteSettings
    })
  }
}
</script>

<style></style>
